/**
 * State Manager - Gestione centralizzata dello stato
 */

export class StateManager {
  constructor() {
    this.state = {
      isPlaying: false,
      currentTime: 0,
      duration: 0,
      volume: 1,
      previousVolume: 1,
      isMuted: false,
      isLoading: false,
      // Sistema ads (v3.0.0+)
      isAdPlaying: false,
      currentAdType: null,     // 'preroll' | 'midroll' | 'postroll'
      currentAdId: null,
      adsPlayed: []            // Array di ad IDs riprodotte
    };
    
    this.listeners = new Map();
  }
  
  /**
   * Ottieni stato corrente
   * @returns {Object} Stato
   */
  getState() {
    return { ...this.state };
  }
  
  /**
   * Aggiorna stato
   * @param {Object} updates - Aggiornamenti
   */
  setState(updates) {
    const prevState = { ...this.state };
    this.state = { ...this.state, ...updates };
    
    // Notifica listeners
    this.notifyListeners(prevState, this.state);
  }
  
  /**
   * Sottoscrivi cambiamenti stato
   * @param {Function} listener - Callback
   * @returns {Function} Funzione per unsubscribe
   */
  subscribe(listener) {
    const id = Symbol();
    this.listeners.set(id, listener);
    
    return () => this.listeners.delete(id);
  }
  
  /**
   * Notifica tutti i listeners
   * @param {Object} prevState - Stato precedente
   * @param {Object} newState - Nuovo stato
   */
  notifyListeners(prevState, newState) {
    this.listeners.forEach(listener => {
      try {
        listener(newState, prevState);
      } catch (e) {
        console.error('Error in state listener:', e);
      }
    });
  }
  
  /**
   * Reset stato
   */
  reset() {
    this.setState({
      isPlaying: false,
      currentTime: 0,
      duration: 0,
      volume: 1,
      previousVolume: 1,
      isMuted: false,
      isLoading: false,
      isAdPlaying: false,
      currentAdType: null,
      currentAdId: null,
      adsPlayed: []
    });
  }
}

